// (function () {
//     'use strict';

//     angular.module("imApp").factory("dispatchPlanningBlockOrderService", ['$ihttp', function ($ihttp) {
//         let service = {
//             listBlockOrders: function (parms) {
//                 return $ihttp.post({
//                     method: 1572,
//                     parameters: parms || {}
//                 });
//             }
//         };

//         return service;
//     }]);
// })();
